<div class="grid-template">
  <div id="graph">
    <canvas
      id="statisticsChart"
      baseChart
      role="img"
      [attr.aria-label]="summary"
      [datasets]="datasets"
      [labels]="labels"
      [options]="options"
      chartType="bar"
    >
      {{ summary }}
    </canvas>
  </div>
  <div class="turns-col">
    <div class="flex-basis-1 text-center">
      <div class="auto-top-bottom-margin">
        <h1 class="number-cycle">
          {{ data.cycles }}
        </h1>
      </div>
      <div class="flex-center">
        <svg-icon
          class="pr-xs recycle mt-xxxs"
          src="/assets/icons/loop.svg"
          style="fill: #ff6400"
          [svgStyle]="{ 'width.px': 14, 'height.px': 14 }"
        ></svg-icon>
        <span class="legend">Turns</span>
      </div>
    </div>
  </div>
</div>
